module.exports = __webpack_public_path__ + "img/basketball_c2.c3ff5abd.svg";